import { withNamespaces } from 'react-i18next'
import { connect } from 'react-redux'
import axios from 'axios'
import Spinner from 'react-bootstrap/Spinner'
import { toast } from 'react-toastify'
import { useState } from 'react'
import { API_BASE_URL } from 'src/modules/data-protection/constants'

const download = async ({ token, params, onDownloadProgress, cancelToken }) => {
    return axios.get(
        `${API_BASE_URL}/other_asset/download`,
        {
            params: params,
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${token}`
            },
            onDownloadProgress: onDownloadProgress,
            cancelToken: cancelToken
        }
    )
}

const ExportExcelButton = ({ 
    t, 
    token,
    filters
}) => {
    const [downloadOptions, setDownloadOptions] = useState({
        percent: 0,
        status: null,
        cancelToken: null
    })

    const handleDownload = async () => {
        if(downloadOptions.status === 'downloading') return;

        const cancelToken = axios.CancelToken.source()

        setDownloadOptions({
            percent: 0,
            status: 'downloading',
            cancelToken: cancelToken
        })

        let loadedBytes = 0

        try {
            const response = await download({
                onDownloadProgress: (progressEvent) => {
                    loadedBytes = progressEvent.loaded

                    const percentCompleted = Math.round(
                        (loadedBytes * 100) / progressEvent.total
                    )

                    setDownloadOptions((currentState) => {
                        return {...currentState, percent: percentCompleted}
                    })
                },
                params: {
                    ...filters,
                    pageIndex: undefined,
                    pageSize: undefined
                },
                cancelToken: cancelToken.token,
                token
            })
    
            const url = window.URL.createObjectURL(
                new Blob([response.data], { type: '*' })
            )

            const link = document.createElement('a')
    
            link.href = url
            link.setAttribute('download', 'Other Assets.xlsx')
    
            document.body.appendChild(link)
    
            link.click()
            link.remove()

            setDownloadOptions({
                percent: 0,
                status: 'finished',
                cancelToken: null
            })
        } 
        catch (error) {
            let status;
            if (axios.isCancel(error)) {
                status = 'canceled'
                toast(t('Download cancelled.'), {
                    type: 'success',
                })
            } 
            else {
                status = 'faild'
                toast(t('An error occurred while downloading the file.'), {
                    type: 'error'
                })
            }

            setDownloadOptions({
                percent: 0,
                status: status,
                cancelToken: null
            })
        }
    }

    return (
        <div
            onClick={handleDownload}
        >
            {downloadOptions.status === 'downloading' ? (
                <>
                    <Spinner
                        animation='border'
                        variant='primary'
                        size='sm'
                        className='me-1'
                    />
                    {t('Exporting')}{` ${downloadOptions.percent}%`}
                    
                </>
            ) : (
                <>
                    <i className='ri-file-excel-2-line align-middle me-2' />
                    {t(
                        'Export as Excel'
                    )}
                </>
            )}
        </div>
    )
}

const mapToState = (state) => {
    const { token } = state.Login

    return {
        token
    }
}

export default withNamespaces()(
    connect(mapToState, {})(
        ExportExcelButton
    )
)